import _ from 'lodash';

import account from './account';
import authentication from './authentication';
import booking from './booking';
import billing from './billing';
import cta from './cta';
import common from './common';
import country from './country';
import conversation from './conversation';
import event from './event';
import field from './field';
import notification from './notification';
import pricing from './pricing';
import pwa from './pwa';
import spot from './spot';
import support from './support';

const translations = _.merge(
  account,
  authentication,
  booking,
  billing,
  cta,
  common,
  country,
  conversation,
  event,
  field,
  notification,
  pricing,
  pwa,
  spot,
  support
);

export default translations;
